var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DB2828;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 6.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -6.1633 14.9791)",
    className: "st0",
    width: 2.9,
    height: 17.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.4,
    y: 13.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -6.1924 15.0499)",
    className: "st0",
    width: 17.3,
    height: 2.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/red_cross.9cedad138e3eed50342437813f3f9208.svg";
export { ForwardRef as ReactComponent };